// extracted by mini-css-extract-plugin
module.exports = {"VideoConsent_NotAccepted":"VideoConsent_VideoConsent_NotAccepted__4fm4T","VideoConsent_NotAcceptedAction":"VideoConsent_VideoConsent_NotAcceptedAction___TyNW"};